<link href="https://unpkg.com/bootstrap-css-only@4.4.1/css/bootstrap.min.css" rel="stylesheet">
<link href="https://unpkg.com/@fortawesome/fontawesome-free@5.15.1/css/all.css" rel="stylesheet">
<!--<link href="https://unpkg.com/angular-calendar@0.28.22/css/angular-calendar.css" rel="stylesheet">-->
<link href="https://unpkg.com/flatpickr@4.6.6/dist/flatpickr.css" rel="stylesheet">
<div id="fab-dismiss" *ngIf="fabTogglerState==='active'" (click)="onToggleFab()">
</div>
<div class="fab-container ">
  <button mat-fab class="fab-toggler" (click)="onToggleFab()">
    <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">add</i> <!-- Animation here -->
  </button>
  <div [@speedDialStagger]="buttons.length">
    <button *ngFor="let btn of buttons" mat-mini-fab class="fab-secondary  " color="secondary">

      <i class="material-icons " (click)='openFABModal(btn.icon)' title={{btn.title}}>{{btn.icon}}</i>


    </button>
  </div>
</div>



<!--*********************************************************************************************************************************************************************************************************************************-->

<!-- Header Section -->
<div class="page-header col-md-12 p-3">
  <div class="row">
    <div class="col-md-4">
      <h3 class="page-title" translate>Schedule - {{branch}}</h3>
      <ol class="breadcrumb bg-white p-0">
        <li class="breadcrumb-item active" aria-current="page">Schedule</li>
      </ol>
    </div>
    <div class="col-md-8 d-none d-md-flex justify-content-md-end align-items-center">
      <button class="btn mx-1 border border-white rounded" routerLink="/schedule_administration"
        translate>Settings</button>
      <button class="btn mx-1 border border-white rounded" (click)="checkIn()" translate>Check In</button>
      <button class="btn mx-1 border border-white rounded" (click)="openBlockOffDayModal(blockoffdayModal)"
        translate>Block Off Time</button>
      <button class="btn mx-1 border border-white rounded" (click)="openDayOffModal(dayoffModal)" translate>Assign Day
        Off</button>
      <button class="btn mx-1 border border-white rounded" routerLink="/create-appointment" translate>New
        Appointment</button>
      <button class="btn mx-1 border border-white rounded" (click)="openLunchModal(lunchModal)" translate>Lunch
        Assignment</button>
    </div>

    <!-- Mobile Dropdown -->
    <div class="col-12 d-flex d-md-none justify-content-end">
      <div ngbDropdown class="d-flex d-md-none justify-content-end mt-2">
        <button class="btn btn-light border no-arrow" ngbDropdownToggle>
          <i class="fa fa-ellipsis-h"></i>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-right">
          <a class="dropdown-item border-bottom p-2" routerLink="/schedule_administration" translate>Settings</a>
          <a class="dropdown-item border-bottom p-2" href="#" (click)="checkIn()" translate>Check In</a>
          <a class="dropdown-item border-bottom p-2" href="#" (click)="openBlockOffDayModal(blockoffdayModal)"
            translate>Block Off Time</a>
          <a class="dropdown-item border-bottom p-2" href="#" (click)="openDayOffModal(dayoffModal)"
            translate>Assign</a>

          <a class="dropdown-item border-bottom p-2" href="#" (click)="openDayOffModal(dayoffModal)" translate>Assign
            Day Off</a>
          <a class="dropdown-item border-bottom p-2" routerLink="/create-appointment" translate>New Appointment</a>
          <a class="dropdown-item border-bottom p-2" href="#" (click)="openLunchModal(lunchModal)" translate>Lunch
            Assignment</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Calendar Section -->
<div class="row mt-2 mx-0 p-5 bg-white ">
  <div class="px-3 ">
    <div class="btn-group">
      <div class="btn btn-primary" mwlCalendarPreviousView [view]="'day'" [(viewDate)]="viewDate">
        Previous
      </div>
      <div class="btn btn-outline-secondary" mwlCalendarToday [(viewDate)]="viewDate">
        Today
      </div>
      <div class="btn btn-primary" mwlCalendarNextView [view]="'day'" [(viewDate)]="viewDate">
        Next
      </div>
    </div>
  </div>
  <div class="col-md-6 text-right">
    <h3>{{ viewDate | calendarDate:('dayViewTitle') }}</h3>
  </div>
</div>



<!-- Calendar with Horizontal Scroll -->
<div style="overflow-x: auto; width: 100%; max-width: 100%; ">
  <div class="row px-2" style="min-width: 150%; padding-bottom: 20px; ">
    <mwl-day-view-scheduler style="min-width: 150%;" [viewDate]="viewDate" [events]="events" [users]="tableusers"
      [refresh]="refresh" [dayStartHour]="8" [dayEndHour]="18" (eventClicked)="eventClicked($event)"
      (eventTimesChanged)="eventTimesChanged($event)" (userChanged)="userChanged($event)">
    </mwl-day-view-scheduler>
  </div>
</div>







<!--*********************************************************************************************************************************************************************************************************************************-->
<!--List sales rep to be assigned to browsing appointemnt-->
<button id="openBrowsingAssignmentModalButton" [hidden]="true" data-toggle="modal"
  data-target="#BrowsingAssignmentModal">Open Modal</button>
<!-- Modal -->
<div id="BrowsingAssignmentModal" class="modal fade" role="dialog">
  <div class="modal-dialog" style="min-height: 15%; min-width: 35%; background: white;">

    <!-- Modal content-->
    <div class="modal-content " style="min-height: 15%; min-width: 35%; background: white;">
      <div class="modal-header">
      </div>
      <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 35%; background: white;"
        id="todayTableview">
        <div class=" d-flex justify-content-between row  mt-2 mx-1">

          <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 "
            style="min-width: 35%;">
            <div id="notificationSlide" class="carousel slide " data-ride="carousel">



              <!-- The slideshow -->
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class=" border p-3 m-1 rounded   ">
                    <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: #132a42;">
                      <strong translate>Browsing Assignment</strong>
                      <div class="p-1 mr-3">

                      </div>
                    </h6>
                    <div class="d-flex justify-content-between w-100">
                      <button class="w-100  text-white rounded p-2" style="background-color: #132a42;"
                        (click)='updateSalesRepListForBrowsing()'><i class="fa fa-lock"></i></button>
                      <button class="w-100  text-white rounded p-2" style="background-color: #132a42;"
                        (click)='resetBrowsingAssignmentSalesRep()' translate>RESET</button>
                    </div>



                    <div class="example-list  text-center" cdkDropList (cdkDropListDropped)="drop($event)">
                      <ng-container *ngFor='let list of browsingSalesReplist;let indexOfelement=index;'>

                        <ng-container *ngIf='salesrepfreenext.includes(list.fullName) else notavailablerep'>
                          <div class="example-box text-center row w-100 m-0 text-success border " type="button"
                            style="cursor: pointer;" (click)=assignSalesRepToBrowsing(list,indexOfelement) cdkDrag>
                            <div class="col-md-8 m-0 text-center  ">{{list.fullName}}</div>
                            <div class="col-md-4">{{list.count}}</div>

                            <!--<td  class="p-2 border " style="cursor: pointer;" (click)="openClientDetails(list)" data-dismiss="modal">{{list}}</td>-->

                          </div>
                        </ng-container>
                        <ng-template #notavailablerep>
                          <div class="example-box text-center text-danger border m-0 row w-100" cdkDrag>
                            <div class="col-md-8 m-0  text-center ">{{list.fullName}}</div>
                            <div class="col-md-4 ">{{list.count}}</div>
                          </div>
                        </ng-template>
                      </ng-container>
                    </div>




                  </div>
                </div>

              </div>


            </div>

          </div>



        </div>

      </div>



    </div>
  </div>
</div>


<!----------Sales Rep Browsing Assignment Confirmation Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #confirmBrowsingAssignModal let-modal>
  <div class="modal-header" style="z-index: 9999999;">
    <h5 class="modal-title" id="statuLabel" translate>Browsing Assignment</h5>
    <button type="button" class="close" style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="assignSalesRepBrowsingForm">
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
      </div>

      <div class="form-group row">
        <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold" translate> Sales Representative </label>
        <div class="col-sm-8 input-group">
          <input type="text" formControlName="salesRep" class="form-control bg-white border-0 font-weight-bolder"
            disabled />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
        <button type="submit" class="btn btn-primary" (click)=saveSalesRepBrowsingAssignment();
          translate>Confirm</button>
      </div>
    </form>
  </div>
</ng-template>

<!--*********************************************************************************************************************************************************************************************************************************-->
<!--List of Browsing appointment to be assigned to sales rep-->
<button id="openBrowsingListModalButton" [hidden]="true" data-toggle="modal" data-target="#BrowsingListModal">Open
  Modal</button>
<!-- Modal -->
<div id="BrowsingListModal" class="modal fade" role="dialog" style="z-index: 10000; overflow: scroll;">
  <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">

    <!-- Modal content-->
    <div class="modal-content " style="min-height: 15%; min-width: 68%; background: white;">
      <div class="modal-header">
      </div>
      <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;"
        id="todayTableview">
        <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">

          <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 "
            style="min-width: 68%;">
            <div id="notificationSlide" class="carousel slide " data-ride="carousel">



              <!-- The slideshow -->
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class=" border p-3 m-1 rounded   ">
                    <h6 class="table-heading rounded text-white text-center p-3 bg-dark"><strong translate>Browsing
                        Appointment</strong>
                      <div class="p-1 mr-3">
                        <form role="form" method="post" [formGroup]="searchForm">
                          <input class=" p-2 m-2 w-100 mx-2 text-center rounded form-control"
                            formControlName='searchPhoneText' type="text" placeholder="Search by Phone Number"
                            aria-label="Search">

                        </form>
                      </div>
                    </h6>

                    <div style="overflow:scroll;">
                      <table class="table w-100  text-center" style="font-size: 12px; overflow:scroll;">



                        <table class="col-md-12 border" *ngIf="allbrowsingappointmentfortoday!='' else elseblock">
                          <thead class="border">
                            <th class=" p-2" translate>Full Name</th>
                            <th class="text-center p-2" translate>Request Type</th>
                            <th class="text-center p-2" translate>Sales Rep</th>
                            <th class="text-center p-2" translate>Phone</th>
                            <th class="text-center p-2" translate>Time In</th>
                            <th class="text-center p-2" translate>Time Out</th>
                            <th class="text-center p-2" translate>Tag</th>
                            <th class="text-center p-2" translate>Status</th>
                            <!--<th class="text-center p-2">Action</th>
                            <th></th>-->
                          </thead>
                          <tr *ngFor='let list of allbrowsingappointmentfortoday | filter:searchText'>


                            <td class="p-3" (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.fullName}}</td>
                            <td class="text-center p-3"
                              (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.requestType}}</td>
                            <td class="text-center p-3"
                              (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.salesRep}}</td>
                            <td class="text-center p-3"
                              (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.phoneNumber}}</td>
                            <td class="text-center p-3"
                              (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.timeIn | date:'yyyy-M-d h:mm a'}}</td>
                            <td class="text-center p-3"
                              (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.timeOut | date:'yyyy-M-d h:mm a'}}</td>
                            <td class="text-center p-3"
                              (click)=openConfirmBrowsingAssignModal(confirmBrowsingAssignModal,list)
                              style="cursor: pointer;">{{list.tag}}</td>




                            <td *ngIf="list.status==''" class="text-warning text-center  p-3">
                              <strong>{{list.status}}</strong>
                            </td>
                            <td *ngIf="list.status=='Pending'" class="text-warning text-center  p-3">
                              <strong>{{list.status}}</strong>
                            </td>
                            <td *ngIf="list.status=='No Show'" class="text-danger text-center  p-3">
                              <strong>{{list.status}}</strong>
                            </td>
                            <td *ngIf="list.status=='In Progress'" class="text-primary text-center  p-3">
                              <strong>{{list.status}}</strong>
                            </td>
                            <td *ngIf="list.status=='Completed'" class="text-success text-center  p-3">
                              <strong>{{list.status}}</strong>
                            </td>
                            <td *ngIf="list.status=='Cancelled'" class="text-danger text-center  p-3">
                              <strong>{{list.status}}</strong>
                            </td>

                            <!--<td class="p-2" *ngIf="isReceptionist() || isAdmin() || isSystemAdmin() ">
                                    <i  aria-hidden="true" title="In Progress" class="fas fa-ellipsis-h text-info p-2" style="cursor: pointer;" (click)="openInProgressModal(inProgressModal,list)"></i>
                                    <i aria-hidden="true" title="Cancel" class="far fa-times-circle text-danger p-2" style="cursor: pointer;" (click)="cancelAppointment(list)"></i>
                                    <i aria-hidden="true" title="Complete" class="far fa-check-circle text-success p-2" style="cursor: pointer;" (click)="completeAppointment(list)"></i>
                                    <i aria-hidden="true" title="Edit" class="fa fa-edit text-dark p-2" style="cursor: pointer;" (click)="editAppointment(list)" ></i>
                                    <i aria-hidden="true" title="Tag" class="fa fa-tag text-warning p-2" style="cursor: pointer;" (click)=openTagModal(tagModal,list)></i>
                                    <i aria-hidden="true" title="Delete" class="fa fa-trash p-2 text-dark" style="cursor: pointer;"(click)="deleteAppointment(list)"></i>
                                   
                                </td>
                               
                                           <td> <i class="fa fa-toggle-on text-info p-2" style="cursor: pointer;" (click)=clearbarScanAppointment(list)></i></td>
                            -->
                          </tr>




                        </table>


                        <ng-template #elseblock>
                          <td class="p-3 border" data-dismiss="modal" style="cursor: pointer;" translate>"No Results"
                          </td>
                        </ng-template>
                      </table>
                    </div>
                  </div>
                </div>

              </div>


            </div>

          </div>



        </div>

      </div>



    </div>
  </div>
</div>



<!--*********************************************************************************************************************************************************************************************************************************-->
<button id="openClientSearchModalButton" [hidden]="true" data-toggle="modal" data-target="#ClientSearchModal">Open
  Modal</button>
<!-- Modal -->
<div id="ClientSearchModal" class="modal fade" role="dialog">
  <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">

    <!-- Modal content-->
    <div class="modal-content " style="min-height: 15%; min-width: 68%; background: white;">
      <div class="modal-header">
      </div>
      <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;"
        id="todayTableview">
        <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">

          <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 "
            style="min-width: 68%;">
            <div id="notificationSlide" class="carousel slide " data-ride="carousel">



              <!-- The slideshow -->
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class=" border p-3 m-1 rounded   ">
                    <h6 class="table-heading rounded text-white text-center p-3 "
                      style="background-color: rgb(17, 47, 77);"><strong translate>Client Search</strong>
                      <div class="p-1 mr-3">
                        <form role="form" method="post" [formGroup]="searchForm">
                          <input class=" p-2 m-2 w-100 mx-2 text-center rounded form-control"
                            formControlName='searchPhoneText' type="text" placeholder="Search by Phone Number"
                            aria-label="Search">
                          <button class="btn  mx-1 border border-white rounded text-white"
                            style="background-color: rgb(17, 47, 77);"
                            (click)='clientSearch(searchForm.get("searchPhoneText").value)'>Submit</button>
                        </form>
                      </div>
                    </h6>

                    <div style="overflow:auto;">
                      <table class="table w-100  text-center" style="font-size: 12px;">


                        <ng-container *ngFor='let list of clientSearchList'>
                          <table class="col-md-12 border" *ngIf="list!='no clients found' else elseblock">
                            <thead class="border">
                              <th class=" p-2 border" translate>Full Name</th>
                              <th class="text-center p-2 border" translate>Phone Number</th>
                              <th class="text-center p-2 border" translate>Email</th>
                            </thead>
                            <tr>

                              <td class="p-2 border " style="cursor: pointer;" (click)="openClientDetails(list)"
                                data-dismiss="modal">{{list.fullName}}</td>
                              <td class="p-2 border" style="cursor: pointer;" (click)="openClientDetails(list)"
                                data-dismiss="modal">{{list.phoneNumber}}</td>
                              <td class="p-2 border" style="cursor: pointer;" (click)="openClientDetails(list)"
                                data-dismiss="modal">{{list.email}}</td>



                            </tr>
                          </table>
                        </ng-container>

                        <ng-template #elseblock>
                          <td class="p-3 border" data-dismiss="modal" style="cursor: pointer;">"No Results"</td>
                        </ng-template>
                      </table>
                    </div>
                  </div>
                </div>

              </div>


            </div>

          </div>



        </div>

      </div>



    </div>
  </div>
</div>




<!--*********************************************************************************************************************************************************************************************************************************-->
<button id="openSalesRepAvailabilityModalButton" [hidden]="true" data-toggle="modal"
  data-target="#SalesRepAvailabilityModal">Open Modal</button>
<!-- Modal -->
<div id="SalesRepAvailabilityModal" class="modal fade" role="dialog">
  <div class="modal-dialog" style="min-height: 15%; min-width: 68%; background: white;">

    <!-- Modal content-->
    <div class="modal-content" style="min-height: 15%; min-width: 68%; background: white;">
      <div class="modal-header">
      </div>
      <div class="col-md-12 bg-muted p-0  " style="min-height: 15%; min-width: 68%; background: white;"
        id="todayTableview">
        <div class=" d-flex justify-content-between row w-95 mt-2 mx-1">

          <div class=" col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white p-1 "
            style="min-width: 68%;">
            <div id="notificationSlide" class="carousel slide " data-ride="carousel">



              <!-- The slideshow -->
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <div class=" border p-3 m-1 rounded   ">
                    <h6 class="table-heading rounded text-white text-center p-3"
                      style="background-color: rgb(17, 47, 77);"><strong translate>Sales Representative
                        Availability</strong>
                      <div class="p-1 mr-3">
                        <input class=" p-2 m-2 w-100 mx-2 text-center rounded " type="text" placeholder="Search"
                          [(ngModel)]="searchText" aria-label="Search">
                      </div>
                    </h6>

                    <div style="overflow:auto;">
                      <table class="table w-100  text-center" style="font-size: 12px;">





                        <tr *ngFor='let list of tablerequestTypearray |  filter:searchText'>
                          <ng-container *ngFor='let table of list | keyvalue'>
                            <td *ngIf="table.key==' ' else elseblock" class="p-3 border">{{table.value}}</td>

                            <ng-template #elseblock>
                              <td class="p-3 border" data-dismiss="modal" style="cursor: pointer;"
                                (click)='createAptFromFreeTime(list[" "],table.value)'>{{table.value}}</td>
                            </ng-template>
                          </ng-container>
                        </tr>


                      </table>
                    </div>
                  </div>
                </div>

              </div>


            </div>

          </div>



        </div>

      </div>



    </div>
  </div>
</div>




<!----------OLD block Off Time Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #oldblockoffdayModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="statuLabel">Block Off Time</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="blockoffdayForm">

      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
        <label class="col-sm-4 col-form-label font-weight-bold">Request Type</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="requestType"
            id="requestType">
            <option value="">Select</option>
            <option data-tagprefix='' *ngFor='let list of requestTypeList' value={{list}}>{{list}}</option>
          </select>
        </div>
      </div>


      <div class="form-group row">

        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="salesRep" id="salesRep">
            <option value="">Select</option>
            <option data-tagprefix='' *ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}</option>
          </select>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Description</label>
        <div class="col-sm-8">
          <input class="px-2 form-control" formControlName="fullName" id="fullName" type="text">
        </div>
      </div>



      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select Start Time </label>
        <div class="col-sm-8 input-group">

          <app-date-time-picker formControlName="blockoffDaytimeIn" [class.is-invalid]="formErrors.blockoffDaytimeIn"
            (blur)="logValidationErrors()" name="blockoffDaytimeIn"></app-date-time-picker>

        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select End Time </label>
        <div class="col-sm-8 input-group">

          <app-date-time-picker formControlName="blockoffDaytimeOut" [class.is-invalid]="formErrors.blockoffDaytimeOut"
            (blur)="logValidationErrors()" name="blockoffDaytimeOut"></app-date-time-picker>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
        <button type="submit" class="btn btn-primary" [disabled]='!blockoffdayForm.valid || !blockoffdayForm.valid'
          (click)=saveIndividualBlockoffday(); translate>Confirm</button>
      </div>
    </form>
  </div>
</ng-template>

<!----------Block Off Day Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #blockoffdayModal let-modal>
  <div class="modal-header text-white" style="background-color: rgb(17, 47, 77);">
    <h5 class="modal-title" id="statuLabel" translate>Block Off Time</h5>
    <button type="button" class="close text-white" style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="blockoffdayForm">

      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
        <label class="col-sm-4 col-form-label font-weight-bold">Request Type</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="requestType"
            id="requestType">
            <option value="">Select</option>
            <option data-tagprefix='' *ngFor='let list of requestTypeList' value={{list}}>{{list}}</option>
          </select>
        </div>
      </div>


      <!-- <div class="form-group row">
       
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold">Sales Representative</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="salesRep" id="salesRep">
            <option value=""  >Select</option>
            <option data-tagprefix=''*ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}</option>
           </select>
        </div>
       </div>-->

      <div class="form-group row  ">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
        <label for="userName" class="col-sm-12 w-100 col-form-label font-weight-bold" translate>Sales
          Representative</label>


        <div class="ml-5 w-25  d-flex flex-wrap" *ngFor='let rep of mainSalesReplist' style=" float:right; ">
          <div class="w-100 ">
            <input type="checkbox" class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"
              (change)="selectSalesRep($event.target.checked,'blockOff',rep)">
            <label class="form-check-label px-1 pb-2 w-100">
              {{rep.fullName}}
            </label>
          </div>

        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Description</label>
        <div class="col-sm-8">
          <input class="px-2 form-control" formControlName="fullName" id="fullName" type="text">
        </div>
      </div>



      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select Start Time </label>
        <div class="col-sm-8 input-group">

          <app-date-time-picker formControlName="blockoffDaytimeIn" [class.is-invalid]="formErrors.blockoffDaytimeIn"
            (blur)="logValidationErrors()" name="blockoffDaytimeIn"></app-date-time-picker>

        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-4 col-form-label font-weight-bold" translate> Select End Time </label>
        <div class="col-sm-8 input-group">

          <app-date-time-picker formControlName="blockoffDaytimeOut" [class.is-invalid]="formErrors.blockoffDaytimeOut"
            (blur)="logValidationErrors()" name="blockoffDaytimeOut"></app-date-time-picker>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
        <button type="submit" class="btn btn-primary" [disabled]='!blockoffdayForm.valid || !blockoffdayForm.valid'
          (click)=saveBlockoffday(); translate>Confirm</button>
      </div>
    </form>
  </div>
</ng-template>




<!----------OLD Day Off Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #olddayoffModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="statuLabel">Day Off Assignment</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="dayoffForm">
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
        <label for="userName" class="col-sm-4 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="col-sm-8">
          <select class="form-control  select2 select2-hidden-accessible " formControlName="salesRep" id="salesRep">
            <option value="">Select</option>
            <option data-tagprefix='' *ngFor='let rep of salesReplist' value={{rep.userID}}>{{rep.fullName}}</option>
          </select>
        </div>
      </div>


      <div class="form-group row">
        <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold" translate> Select Date </label>
        <div class="col-sm-8 input-group">
          <input type="text" class="form-control" formControlName="dayoffDate" id="dayoffDate" name="dayoffDate"
            bsDatepicker placement="top right" autocomplete="off" [bsConfig]="datePickerConfig"
            [class.is-invalid]="formErrors.dayoffDate" (blur)="logValidationErrors()"><i
            class="input-group-addon  border p-2 fa fa-calendar fa-lg"></i>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
        <button type="submit" class="btn btn-primary" (click)=saveIndividualDayoff(); translate>Confirm</button>
      </div>
    </form>
  </div>
</ng-template>




<!----------Day Off Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #dayoffModal let-modal>
  <!-- {{dayoffForm.value |json}} -->
  <div class="modal-header text-white " style="background-color: rgb(17, 47, 77);">
    <h5 class="modal-title" id="statuLabel" translate>Day Off Assignment</h5>
    <button type="button" class="close text-white" style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="dayoffForm">
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
        <label for="userName" class="col-sm-12 col-form-label font-weight-bold" translate>Sales Representative</label>
        <div class="ml-5 w-25 d-flex flex-column " *ngFor='let rep of mainSalesReplist'
          style=" float:right; max-height: 550px;">
          <div class="w-100">
            <input type="checkbox" class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"
              (change)="selectSalesRep($event.target.checked,'DayOff',rep)">
            <label class="form-check-label px-1 pb-2 w-100">
              {{rep.fullName}}
            </label>
          </div>

        </div>
      </div>


      <!--<div class="form-group row">
        <label for="newBranch" class="col-sm-4 col-form-label font-weight-bold"> Select Date </label>
        <div class="col-sm-8 input-group">
          <input type="text" class="form-control" formControlName="dayoffDate"
          id="dayoffDate" name="dayoffDate" bsDatepicker placement="top right" autocomplete="off" 
          [bsConfig]="datePickerConfig" [class.is-invalid]="formErrors.dayoffDate" (blur)="logValidationErrors()"><i
          class="input-group-addon  border p-2 fa fa-calendar fa-lg"></i>
          
        </div>
      </div>-->
      <div class="w-100 text-center">
        <ngb-multi-date-picker class="w-100" [datesSelected]="datesSelected"
          (datesSelectedChange)="change($event)"></ngb-multi-date-picker>
      </div>
      <hr />

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
        <button type="submit" class="btn btn-primary" (click)=saveDayoff(); translate>Confirm</button>
      </div>
    </form>
  </div>

</ng-template>
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Block/Day Off Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openOffSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#blockOffSuccessModal">Open
  Modal</button>
<!-- Modal -->
<div id="blockOffSuccessModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">

        <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
      </div>
      <div class="modal-body " style="background: black;">
        <div class="row p-5 ">
          <div class="col-sm-12 w-100">
            <div class="d-flex flex-column justify-content-between  row w-100 m-0">


              <img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                src="./assets/logo2020w.png" />


              <div class="w-100 text-center">
                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
              </div>
              <div class="modal-body text-danger" *ngFor='let x of OffMessage'>
                <p class="my-0 py-0">{{x}}</p>
              </div>
              <div class="border  bg-white "></div>
              <div class="w-100 text-center">
                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Your changes have been
                  saved</h4>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default text-center" (click)="refreshPage()" data-dismiss="modal"
          translate>Close</button>
      </div>
    </div>

  </div>
</div>


<!----------Lunch Assignment Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
<ng-template #lunchModal let-modal>
  <div class="modal-header text-white" style="background-color: rgb(17, 47, 77);">
    <h5 class="modal-title" id="statuLabel">Lunch Assignment</h5>
    <button type="button" class="close text-white" style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="lunchForm">
      <div class="form-group row">
        <input type="text" disabled class="form-control bg-white border-0 font-weight-bolder" formControlName="modalMsg"
          id="modalMsg">
        <label for="userName" class="col-sm-12 col-form-label w-100 font-weight-bold" translate>Sales
          Representative</label>
        <div class="ml-5 w-25 d-flex flex-column " *ngFor='let rep of mainSalesReplist'
          style=" float:right; max-height: 450px;">
          <div>
            <input type="checkbox" class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"
              (change)="selectSalesRep($event.target.checked,'Lunch',rep)">
            <label class="form-check-label px-1 pb-2 w-100">
              {{rep.fullName}}
            </label>
          </div>

        </div>
      </div>


      <div class="form-group row">
        <label for="newBranch" class="col-sm-12 col-form-label font-weight-bold" translate> Lunch Date </label>
        <div class="col-sm-12 input-group w-100">
          <!--<ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden">
      </ngb-datepicker>
      
      <ng-template #t let-date let-focused="focused">
        <span class="custom-day"
              [class.focused]="focused"
              [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)"
              (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
          {{ date.day }}
        </span>
      </ng-template>
      <hr>

<pre>From: {{ fromDate | json }} </pre>
<pre>To: {{ toDate | json }} </pre>-->
          <div class="w-100 text-center">
            <ngb-multi-date-picker [datesSelected]="datesSelected"
              (datesSelectedChange)="change($event)"></ngb-multi-date-picker>
          </div>
          <hr />

          <div class="row mx-0 w-100 py-3">
            <label class="text-center pt-5 font-weight-bold" translate>Lunch Time</label>
            <ngb-timepicker class="mx-4 mb-2" formControlName="lunchTime" meridian="meridian"></ngb-timepicker>
          </div>

          <!--<pre>DateSelected: {{ datesSelected | json }} </pre>-->

          <!--<app-date-time-picker  formControlName="lunchTime"  name="lunchTime"></app-date-time-picker>-->
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
        <button type="submit" class="btn btn-primary" (click)=saveLunch(); translate>Confirm</button>
      </div>
    </form>
  </div>
</ng-template>
<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccesssModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccesssModal">Open
  Modal</button>
<!-- Modal -->
<div id="SuccesssModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">

        <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
      </div>
      <div class="modal-body " style="background: black;">
        <div class="row p-5 ">
          <div class="col-sm-12 w-100">
            <div class="d-flex flex-column justify-content-between  row w-100 m-0">


              <img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                src="./assets/logo2020w.png" />

              <div class="w-100 text-center">
                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
              </div>

              <div class="border  bg-white "></div>
              <div class="w-100 text-center">
                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Your changes has been
                  saved.</h4>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default text-center" (onClick)="reload()" data-dismiss="modal"
          translate>Close</button>
      </div>
    </div>

  </div>
</div>

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Block/Day Off Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openOffSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#OffSuccessModal">Open
  Modal</button>
<!-- Modal -->
<div id="OffSuccessModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">

        <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>-->
      </div>
      <div class="modal-body " style="background: black;">
        <div class="row p-5 ">
          <div class="col-sm-12 w-100">
            <div class="d-flex flex-column justify-content-between  row w-100 m-0">


              <img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                src="./assets/logo2020w.png" />


              <div class="w-100 text-center">
                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
              </div>
              <div class="modal-body text-danger" *ngFor='let x of OffMessage'>
                <p class="my-0 py-0">{{x}}</p>
              </div>
              <div class="border  bg-white "></div>
              <div class="w-100 text-center">
                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Your changes have been
                  saved</h4>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default text-center" (click)='refreshPage()' data-dismiss="modal"
          translate>Close</button>
      </div>
    </div>

  </div>
</div>

<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccesssModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccesssModal">Open
  Modal</button>
<!-- Modal -->
<div id="SuccesssModal" class="modal fade" role="dialog">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">

        <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
      </div>
      <div class="modal-body " style="background: black;">
        <div class="row p-5 ">
          <div class="col-sm-12 w-100">
            <div class="d-flex flex-column justify-content-between  row w-100 m-0">


              <img class="px-3"
                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                src="./assets/logo2020w.png" />

              <div class="w-100 text-center">
                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>THANK YOU </h3>
              </div>

              <div class="border  bg-white "></div>
              <div class="w-100 text-center">
                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';" translate>Your changes has been
                  saved.</h4>
              </div>



            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default text-center" (click)='backClicked()' data-dismiss="modal"
          translate>Close</button>
      </div>
    </div>

  </div>
</div>